var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccumulated = function SvgAccumulated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.8571C23.5 13.4938 22.3345 15.0733 20.2372 16.2718C18.1541 17.4621 15.2428 18.2143 12 18.2143C8.75718 18.2143 5.84595 17.4621 3.76279 16.2718C1.66548 15.0733 0.5 13.4938 0.5 11.8571C0.5 10.2205 1.66548 8.64099 3.76279 7.44253C5.84595 6.25215 8.75718 5.5 12 5.5C15.2428 5.5 18.1541 6.25215 20.2372 7.44253C22.3345 8.64099 23.5 10.2205 23.5 11.8571Z",
    fill: "#9C1C67",
    stroke: "#9C1C67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 14.4286C23.169 17.8111 18.1194 20.4286 12 20.4286C5.88057 20.4286 0.830988 17.8111 0.0928406 14.4286C0.031565 14.7094 0 14.9955 0 15.2857C0 19.0728 5.37258 22.1429 12 22.1429C18.6274 22.1429 24 19.0728 24 15.2857C24 14.9955 23.9684 14.7094 23.9072 14.4286Z",
    fill: "#9C1C67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 17.8572C23.169 21.2397 18.1194 23.8572 12 23.8572C5.88057 23.8572 0.830988 21.2397 0.0928406 17.8572C0.031565 18.138 0 18.424 0 18.7143C0 22.5014 5.37258 25.5715 12 25.5715C18.6274 25.5715 24 22.5014 24 18.7143C24 18.424 23.9684 18.138 23.9072 17.8572Z",
    fill: "#9C1C67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 21.2858C23.169 24.6683 18.1194 27.2858 12 27.2858C5.88057 27.2858 0.830988 24.6683 0.0928406 21.2858C0.031565 21.5666 0 21.8526 0 22.1429C0 25.93 5.37258 29.0001 12 29.0001C18.6274 29.0001 24 25.93 24 22.1429C24 21.8526 23.9684 21.5666 23.9072 21.2858Z",
    fill: "#9C1C67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#9C1C67",
    stroke: "#F0B4D7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.427,
    y: 5.8053,
    width: 3.5441,
    height: 0.608197,
    rx: 0.304098,
    transform: "rotate(45 19.427 5.8053)",
    fill: "#F0B4D7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9143,
    y: 5.43018,
    width: 4.74225,
    height: 0.608197,
    rx: 0.304098,
    transform: "rotate(135 24.9143 5.43018)",
    fill: "#F0B4D7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 5.59998,
    width: 1.88448,
    height: 0.608197,
    rx: 0.304098,
    transform: "rotate(-170.825 24.8 5.59998)",
    fill: "#F0B4D7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.88448,
    height: 0.608197,
    rx: 0.304098,
    transform: "matrix(-0.144538 -0.989499 -0.989499 0.144538 25.1001 6.82971)",
    fill: "#F0B4D7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6092,
    y: 6.26294,
    width: 4.49573,
    height: 0.304098,
    rx: 0.152049,
    transform: "rotate(135 19.6092 6.26294)",
    stroke: "#F0B4D7",
    strokeWidth: 0.304098
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccumulated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accumulated.dc5ddd28.svg";
export { ForwardRef as ReactComponent };